import React from 'react'

import InsideWallModel from './InsideWallModel'
import OutsideWallModel from './OutsideWallModel'

const LeftStorage = () => {
    return (
        <>
            <OutsideWallModel />
            <InsideWallModel />
        </>
    )
}

export default LeftStorage